import { create } from 'zustand';
import { ApiUtils, FileEntity, FolderEntity, RequestStrategyEnum, ResourceEntity, ResourcesApi } from '@shared/api';

interface UseRepositoryStore {
  loading: boolean;
  repository: ResourceEntity[];
  folder: FolderEntity[];
  error: string | null;
  getRepository: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useRepositoryStore = create<UseRepositoryStore>((set) => ({
  loading: false,
  repository: [],
  folder: [],
  error: null,

  getRepository: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await ResourcesApi.getRepository(signal);

      const folderData = result.reduce((acc: { [key: string]: FileEntity[] }, item) => {
        const folderItem = acc[item.folder] || [];
        folderItem.push({
          name: item.file,
          fileName: item.file,
          fileTitle: item.file,
          id: item.id,
          applicationId: '',
          fileType: item.mimeType,
          dateUploaded: new Date().toString(),
        });
        acc[item.folder] = folderItem;
        return acc;
      }, {});
      const folder = Object.keys(folderData).map((folderName, idx) => ({ folderName, folderId: idx, files: folderData[folderName] }));

      set({ loading: false, repository: result ?? [], folder: folder ?? [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, repository: [], error: null }),
}));
